// routes
import { PATH_DASHBOARD } from "../../../routes/paths";

import SvgColor from "../../../components/svg-color";
// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const ICONS = {
  dashboard: icon("dashboard_ic"),
  classes: icon("classes_ic"),
  divisions: icon("classes_ic"),
  families: icon("users_ic"),
  students: icon("student_ic"),
  teachers: icon("users_ic"),
  ads: icon("ads_ic"),
  program: icon("program_ic"),
  notes: icon("notes_ic"),
  profile: icon("profile_ic"),
  contact: icon("contact_us_ic"),
  manager: icon("ic_manager"),
};

const navConfig = [
  // Admin
  // ----------------------------------------------------------------------

  {
    subheader: "dashboard",
    title: "about_educational_institution",
    icon: ICONS.dashboard,
    path: "/overview",
  },
  {
    subheader: "dashboard",
    title: "educational_institution_classes",
    icon: ICONS.classes,
    path: "/classes",
  },
  // {
  //   subheader: "dashboard",
  //   title: "division_info",
  //   icon: ICONS.divisions,
  //   path: "/division_info",
  // },
  {
    subheader: "dashboard",
    title: "educational_institution_families",
    icon: ICONS.students,
    path: "/families",
  },
  {
    subheader: "dashboard",
    title: "educational_institution_students",
    icon: ICONS.students,
    path: "/students",
  },
  {
    subheader: "dashboard",
    title: "educational_institution_teachers",
    icon: ICONS.teachers,
    path: "/teachers",
  },
  {
    subheader: "dashboard",
    title: "ads",
    icon: ICONS.ads,
    path: "/ads",
  },
  {
    subheader: "dashboard",
    title: "sending_notes",
    icon: ICONS.notes,
    path: "/sending-notes",
  },
  {
    subheader: "dashboard",
    title: "reciving_notes",
    icon: ICONS.notes,
    path: "/receiving-notes",
  },
   {
    subheader: "dashboard",
    title: "notifications",
    icon: ICONS.notes,
    path: "/notifications",
  },
  {
    subheader: "dashboard",
    title: "educational_institution_profile",
    icon: ICONS.notes,
    path: "/school-profile",
  },
];

export default navConfig;
